import { call, put, takeLatest } from "@redux-saga/core/effects";

import { ApiService } from "pwapi";

import {
  DELETE_STAIN_ORDER_FAILURE,
  DELETE_STAIN_ORDER_REQUEST,
  DELETE_STAIN_ORDER_SUCCESS,
  LABORDERS_LIST_FAILURE,
  LABORDERS_LIST_REQUEST,
  LABORDERS_LIST_SUCCESS,
  STAIN_ORDER_SUCCESS,
} from "../actions/constants";

function* fetchLabOrders(action: any): any {
  try {
    const results = yield call(
      ApiService.listLabOrders,
      action.payload.filters
    );
    yield put({
      type: LABORDERS_LIST_SUCCESS,
      payload: results,
    });
  } catch (e: any) {
    yield put({
      type: LABORDERS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* cancelOrder(action: any): any {
  try {
    yield put({
      type: DELETE_STAIN_ORDER_SUCCESS,
      payload: action.payload,
    });
    yield call(ApiService.destroyLabOrder, { id: action.payload.id });
  } catch (e) {
    yield put({ type: DELETE_STAIN_ORDER_FAILURE, error: true, payload: e });

    // Reinstating the stain if the cancel order failed
    yield put({
      type: STAIN_ORDER_SUCCESS,
      payload: { response: action.payload },
    });
  }
}

export function* labOrdersSaga() {
  yield takeLatest(LABORDERS_LIST_REQUEST, fetchLabOrders);
  yield takeLatest(DELETE_STAIN_ORDER_REQUEST, cancelOrder);
}
